<template>
  <div class="container-box">

    <div v-swiper:mySwiper="swiperOption">
      <div class="swiper-wrapper">
        <div class="swiper-slide"  
             v-for="(banner, index) in swiperBanners" 
             :key="index"
             :style="{'backgroundImage': 'url(' + banner.src + ')', backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: '100% 100%'}"
          >
          <!-- <img :src="banner.src"> -->
          <div :class="isEn ? 'banner-text-box en-text-box' : 'banner-text-box'">
            <span class="bannerTitle">{{$t(banner.title)}}</span>
            <span class="bannerTip">{{$t(banner.tips1)}}</span>
            <span class="bannerTip">{{$t(banner.tips2)}}</span>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

    <div class="product-box">
      <p :class="isEn ? 'en-desc-p' : ''" v-html="$t('productDes')"></p>
      <!-- <div class="product-flex">
        <home-item v-for="(item, index) in productsArray" 
                   :key="index" 
                   v-bind:item=item>
        </home-item>
      </div> -->
      <el-row >
        <el-col :xs="12"
                :sm="12"
                :md="12"
                :lg="6"
                :xl="6"
                v-for="(item, index) in productsArray" 
                :key="index"
                class="product-item">
            <home-item v-bind:item=item />
        </el-col>
      </el-row>
    </div>

    <div class="service-box">
      <p :class="isEn ? 'en-desc-p' : ''" v-html="$t('serviceDes')"></p>
      <!-- <div class="product-flex">
        <home-item v-for="(item, index) in servicesArray" 
                   :key="index" 
                   v-bind:item=item>
        </home-item>
      </div> -->
      <el-row>
        <el-col :xs="12"
                :sm="8"
                :md="8"
                :lg="8"
                :xl="8"
                v-for="(item, index) in servicesArray" 
                :key="index"
                class="product-item">
            <home-item v-bind:item=item />
        </el-col>
      </el-row>
    </div>

    <div class="partner-box">
      <p>{{$t('partner')}}</p>
      <div class="partner-content">
        <img src="../assets/partner_1.png" />
        <img src="../assets/partner_2.png" />
        <img src="../assets/partner_3.png" />
        <img src="../assets/partner_4.png" />
        <img src="../assets/partner_5.png" />
        <img src="../assets/partner_6.png" />
        <img src="../assets/partner_7.png" />
        <img src="../assets/partner_3.png" />
      </div>
    </div>

    <div class="address-box">
      <p v-html="$t('outfootprint')"></p>
      <div class="address-flex">
        <div class="address-item"
             v-for="(item, index) in addressArray"
             :key="index"
            >
             <img :src="item.icon"/>
             <span class="country">{{$t(item.country)}}</span>
             <span class="address" v-html="$t(item.address)"></span>
        </div>
      </div>
    </div>

    <fix-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer';
import HomeItem from '@/components/HomeItem';

export default {
  
  data(){
    return {

      isEn: false,
      swiperBanners: [
        {
          src: require('../assets/home_top_bg1.png'),
          title: 'bannerTitle',
          tips1: 'bannerTip1',
          tips2: 'bannerTip2',
        },
        // {
        //   src: require('../assets/home_top_bg1.png'),
        //   title: this.$t('bannerTitle'),
        //   tips1: this.$t('bannerTip1'),
        //   tips2: this.$t('bannerTip2'),
        // }
      ],
      swiperOption: {
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        // autoplay: {
        //   delay: 3000,
        //   //当用户滑动图片后继续自动轮播
        //   disableOnInteraction: false,
        // },
        //开启循环模式
        // loop: true
      },

      productsArray:[
        {
          icon: require('../assets/home_eshop.png'),
          title: 'eshop',
          descriptions: [
            'solution'
          ],
          details: [
            'eshopDetail1',
            'eshopDetail2',
            'eshopDetail3',
            'eshopDetail4',
          ]
        },
        {
          icon: require('../assets/home_fintech.png'),
          title: 'fintech',
          descriptions: [
            'solution'
          ],
          details: [
            'fintechDetail1',
            'fintechDetail2',
            'fintechDetail3',
            'fintechDetail4',
          ]
        },
        {
          icon: require('../assets/home_saas.png'),
          title: 'saas',
          descriptions: [
            'solution'
          ],
          details: [
            'saasDetail1',
            'saasDetail2',
          ]
        },
        {
          icon: require('../assets/home_thingnet.png'),
          title: 'thingsnet',
          descriptions: [
            'solution'
          ],
          details: [
            'thingsnetDetail1',
            'thingsnetDetail2',
          ]
        },
      ],

      servicesArray: [
        {
          icon: require('../assets/home_custom.png'),
          title: 'customizonDev',
          descriptions: [
            'customizonTip1',
            'customizonTip2'
          ],
        },
        {
          icon: require('../assets/home_standard.png'),
          title: 'standardProduct',
          descriptions: [
            'standardProductTip1',
            'standardProductTip2'
          ],
        },
        {
          icon: require('../assets/home_extra.png'),
          title: 'extraDomain',
          descriptions: [
            'extraDomainTip1',
            'extraDomainTip2'
          ],
        },
      ],

      addressArray:[
        {
          icon: require('../assets/singpore.png'),
          country: 'singapore',
          address:  'singaporeAddress',
        },
        {
          icon: require('../assets/china.png'),
          country: 'china',
          address:  'chinaAddress',
        },
        {
          icon: require('../assets/india.png'),
          country: 'india',
          address:  'indiaAddress',
        },
        {
          icon: require('../assets/indiaxiya.png'),
          country: 'indonesia',
          address:  'indonesiaAddress',
        },
      ],
    }
  },

  created(){
    const locale = localStorage.getItem('locale');
    if(locale === 'zh'){
      this.isEn = false;
    }else{
      this.isEn = true;
    }
  },

  watch: {
    '$i18n.locale'(){
      const locale = localStorage.getItem('locale');
      if(locale === 'zh'){
        this.isEn = false;
      }else{
        this.isEn = true;
      }
    }
  },

  mounted(){

  },

  methods: {

  },

  components: {
    'fix-footer': Footer,
    'home-item': HomeItem,
  }

}
</script>

<style lang="less" scoped>
.container-box{
  height: 100%;
  overflow: scroll;
}

.swiper-wrapper{
  height: 650px; /*px*/

  .swiper{
    height: 100%;
  }
  .swiper-slide{
    height: 100%;
  }

  .banner-text-box{

    display: flex;
    color: #fff;
    flex-direction: column;
    text-align: left;
    margin-left: 330px;
    padding: 140px 0;/*px*/
    box-sizing: border-box;
    justify-content: space-around;
    height: 100%;

    .bannerTitle {
      font-size: 62px; /*px*/
      margin-bottom: 75px;
      line-height: 75px;/*px*/
    }

    .bannerTip {
      font-size: 30px; /*px*/ 
      margin-bottom: 25px;
      line-height: 32px;/*px*/
    }
  }

  .en-text-box{
    margin-left: 180px;
  }
}

p{
  font-size:32px; 
  font-family:PingFangSC-Semibold,PingFang SC;
  color:rgba(0,0,0,1);
  line-height:50px;
  margin-bottom: 35px;
}
.en-desc-p{
  font-size: 28px;
  display: inline-block;
  // text-align: justify;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-weight: 500;
}

.product-box{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 40px 120px 0;
}

.service-box{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 40px 120px 0;
}

.product-flex{
  // display: flex;
  // flex-direction: row;
  // justify-content: space-around;
}
.product-item{
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.partner-box{
  background-color: #061E34;
  height: 500px; 
  margin-top: 100px;
  box-sizing: border-box;

  p{
    font-size:35px;
    font-family:PingFangSC-Medium,PingFang SC;
    color: #fff;
    padding: 50px 0;
  }
  .partner-content{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0 150px;
    justify-content: space-between;

    img{
      object-fit: contain;
      padding: 0 0 70px;
      width: 160px;
      height: 48px;
      flex: 0 0 25%;
    }
  }
}

.address-box{

  padding: 0 180px;
  box-sizing: border-box;
  height: 500px;

  p{
    color: #061E34;
    font-size: 32px; 
    padding: 30px 0;
  }


  .address-flex{

    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .address-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 0 0 25%;

      img{
        object-fit: contain;
        width: 90px;
        height: 80px;
      }
      .country{
        font-size: 25px; 
        color: #000;
        margin: 45px auto;
      }
      .address{
        font-size: 20px;
        color: #8A8A8A;
        line-height: 1.5;
      }
    }
  }  
}

@media only screen and (max-width: 992px) {

  .container-box{

    .swiper-wrapper{

      .banner-text-box{

        margin-left: 330px;
        padding: 140px 0;/*px*/
        box-sizing: border-box;
        justify-content: space-around;
        height: 100%;

        .bannerTitle {
          font-size: 30px; /*no*/
          line-height: 35px;/*no*/
        }

        .bannerTip {
          font-size: 18px; /*no*/
          margin-bottom: 25px;
          line-height: 25px;/*no*/
        }
      }
    }

    p{
      font-size:20px; /*no*/
      line-height: 30px; /*no*/
    }

    .partner-box{
      height: 290px; /*no*/
      margin-top: 100px;

      p{
        font-size:25px; /*no*/
        padding: 30px 0; /*no*/
      }
      .partner-content{
        padding: 0 50px; /*no*/
        justify-content: space-between;

        img{
          padding: 0 0 50px; /*no*/
          width: 70px; /*no*/
          height: 25px;/*no*/
        }
      }
    }

    .address-box{

      padding: 0 180px;
      height: 250px; /*no*/
      p{
        color: #061E34;
        font-size: 22px; /*no*/
        padding: 30px 0;
      }

      .address-flex{

        .address-item{

          img{
            width: 45px; /*no*/
            height: 40px; /*no*/
          }
          .country{
            font-size: 15px;  /*no*/
            margin: 25px auto; /*no*/
          }
          .address{
            font-size: 12px; /*no*/
            line-height: 20px; /*no*/
          }
        }
      }  
    }


  }


}


</style>


// WEBPACK FOOTER //
// src/pages/Home.vue